import React, { useEffect, useState } from 'react'
import { Navbar, Container, Nav, Stack, DropdownButton, Dropdown } from "react-bootstrap"
import { Link, Trans, useI18next } from 'gatsby-plugin-react-i18next'
import * as styles from "../styles/layout.module.css";

import { ReactComponent as FacebookLogo } from '../assets/facebook_icon.svg'
import { ReactComponent as InstagramLogo } from '../assets/instagram_icon.svg'

import { ReactComponent as Logo } from '../assets/VJF23logo.svg'

const Navigation = () => {

  const [collapsed, setCollapsed] = useState(true)
  const { languages, originalPath, language } = useI18next();

  useEffect(() => {
    if (!collapsed) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'inherit';
    }

  }, [collapsed])

  return (
    <Navbar fixed={'top'} expand='lg' className={styles.navbar_wrapper} id='navbar'>
      <Container fluid>
        <button aria-controls='responsive-navbar-nav' className={`navbar-toggler ${collapsed ? 'collapsed' : ''} ${styles.hamburger_btn}`} onClick={() => setCollapsed(!collapsed)}>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
        <Navbar.Brand className={`${styles.brand}`}>
          <Link to='/'>
            <Logo className={styles.navbar_logo} />
          </Link>
        </Navbar.Brand>
        <Navbar.Collapse className={`${!collapsed ? 'show' : ''} w-100 ${styles.navbar_collapse}`} >
          <Nav className={`${styles.navbar_menu_wrapper}`}>
            <Nav.Item>
              <Link to='/lineup'><Trans>Lineup</Trans></Link>
            </Nav.Item>
            <Nav.Item>
              <Link to='/artists'><Trans>Fellépők</Trans></Link>
            </Nav.Item>
            <Nav.Item>
              <Link to='/tickets'><Trans>Jegyek</Trans></Link>
            </Nav.Item>
            <Nav.Item>
              <Link to='/venue'><Trans>Helyszín</Trans></Link>
            </Nav.Item>
            <Nav.Item>
              <Link to='/summary'><Trans>Összegzés</Trans></Link>
            </Nav.Item>
            <Nav.Item>
              <Link to='/contact'><Trans>Kapcsolat</Trans></Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
        <Dropdown className={styles.navbar_lang_switch_btn}>

          <Dropdown.Toggle variant={'light'} className={styles.navbar_lang_switch_toggle}>
            {language.toUpperCase()}
          </Dropdown.Toggle>

          <Dropdown.Menu variant={'dark'} className={styles.navbar_lang_switch_menu}>
            {languages.map((lng) => (
              <Dropdown.Item key={lng} as={Link} to={originalPath} language={lng} className={styles.navbar_lang_switch_item}>
                {lng.toUpperCase()}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Container>
    </Navbar>
  )
}

export default Navigation